import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { ProductosApiService } from '../../../../service/api/productos-api';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Utils } from '../../../../common/utils';
import { BaseView } from '../../../base-view';
import { environment } from '../../../../../environments/environment';
import moment from 'moment';
import { FormCommonApiService } from '../../../../service/api/formcommon-api.service';
import { SdiApiService } from '../../../../service/api/sdi.service';
import { Filtering } from '../../../../service/filtering/filtering';

import { ColInterface } from '../../../../common/components/common-list-table/col.interface';
import { ProductosModel } from '../../../../models/productos/productos.model';
import { ColStylesInterface } from '../../../../common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { ProductosFitosanitariosEnvironmentDefinition } from './environment-variables';
import { ProductCatalogCacheService } from 'src/app/service/cache/product-catalog-cache.service';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Uso } from 'src/app/models/productos/uso.model';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import {
	ProductosFitosanitariosListFormDefinition,
	ProductosSdiListFormDefinition,
} from './form-control/productos-list-form-definition';

const PRODUCT_DETAIL_CACHE_TTL_MS = 900000;

@Component({
	selector: 'app-productos',
	standalone: false,
	templateUrl: './productos.component.html',
	styleUrls: ['./productos.component.scss'],
})
export class ProductosComponent extends BaseView<ProductosModel> implements OnInit, OnDestroy {
	public env: ProductosFitosanitariosEnvironmentDefinition = new ProductosFitosanitariosEnvironmentDefinition();

	public showInfoCambios = false;

	public getRequest: RequestHandler<ProductosModel[]>;

	public getRequestSdi: RequestHandler<ProductosModel[]>;

	public deleteRequest: RequestHandler<ProductosModel>;

	public pathToForm = 'productos-form';

	public menuItemId = 'fitosanitarios';

	public override canShow: Record<string, boolean> = {};

	public override model: ProductosModel = { nombre: '', materia_activa: '' };

	public isShowingSdiProductos = false;

	public updateVademecum = false;

	public override filtering: Filtering<ProductosModel> = new Filtering<ProductosModel>();

	public typeFilter: { type: string; mes1: number; mes2: number } = {
		type: '',
		mes1: 0,
		mes2: 0,
	};

	public first = 0;

	public tableValues = new RequestHandler();

	public form: ProductosFitosanitariosListFormDefinition | null = null;

	public sdiForm: ProductosSdiListFormDefinition | null = null;

	public readonly serverUrl = environment.serverUrl;

	public cols: ColInterface[] = [
		{ field: 'num_registro', header: 'N˚ Registro', width: '100px' },
		{ field: 'nombre', header: 'Nombre', filter: '', width: '250px' },
		{ field: 'materia_activa', header: 'Materia Activa', width: '240px' },
		{
			field: 'precio',
			header: this.env.appName === 'agrotata' ? 'Precio Coste' : 'Precio',
			filter: '',
			width: '80px',
			visible: environment.features.showPrecio,
		},
		{
			field: 'precio_venta',
			header: 'Precio de Venta',
			filter: '',
			width: '80px',
			visible: environment.features.showPrecio && this.env.appName === 'agrotata',
		},
		{ field: 'unidades', header: 'Unidades', filter: '', width: '80px' },
		{ field: 'envase', header: 'Envase', filter: '', width: '80px' },
		{ field: 'fecha_caducidad', header: 'Fecha Caducidad', width: '140px' },
	];

	public colsSdi: ColInterface[] = [
		// {field: 'codart', header: 'Código', filter: '', width: '60px'},
		{ field: 'descart', header: 'Descripción', filter: '' },
		{ field: 'prcventa', header: 'Precio de venta', filter: '' },
		{ field: 'sdifit_numregistro', header: '# Registro', filter: '', width: '80px' },
		{ field: 'sdifit_composicion', header: 'Composición', filter: '' },
		{ field: 'sdifit_tipoproducto', header: 'Tipo de producto', filter: '' },
		{ field: 'sdiadr_nombre', header: 'Envase', filter: '' },
		{ field: 'texto', header: 'Texto', filter: '' },
		{ field: 'sdifit_nombrecomercial', header: 'Nom. comercial', filter: '' },
	];

	constructor(
		public productosApi: ProductosApiService,
		public sdiApi: SdiApiService,
		private readonly dashboardEvents: DashboardService,
		private readonly router: Router,
		private readonly formApi: FormCommonApiService,
		private readonly productCatalogCache: ProductCatalogCacheService,
	) {
		super(dashboardEvents, productosApi.productos.GET);
		this.getRequest = this.productosApi.productos.GET;
		this.getRequestSdi = this.sdiApi.SdiProductosGET;
		this.deleteRequest = this.productosApi.productos.DELETE;
	}

	ngOnInit() {
		this.dashboardEvents.setSubmenuItem('productos', 'productos-fitosanitarios');
		this.tableValues.isLoading = true;
		this.productosApi.productos.GET.safePerform();
		this.productosApi.productos.GET.response((data) => {
			this.tableValues.isLoading = false;
			this.tableValues.emitResponse(
				data.filter((item: ProductosModel) => {
					if (localStorage.getItem('sm') != null && item.num_registro != null) {
						return item.tipo === 'fitosanitario';
					} else if (localStorage.getItem('sm') == null) {
                        if(item.nombre === undefined || item.nombre === '' ){
                            if(item.producto && item.producto['nombre_comercial']){
                                item.nombre = item.producto['nombre_comercial'];
                            }
                        }
						return item.tipo === 'fitosanitario';
					} else {
						return;
					}
				}),
			);
		});
		this.initFilter();
	}

	public goToVademecum(num_reg: number) {
		this.router.navigate(['dashboard', 'consultas', num_reg.toString()]);
	}

	public addProducto() {
		this.router.navigate(['dashboard', 'crear-producto-fitosanitario']);
	}

	public edit(data: ProductosModel) {
		this.router.navigate(['dashboard', 'editar-producto-fitosanitario', data.id, data]);
	}

	public duplicate(data: ProductosModel) {
		this.router.navigate(['dashboard', 'duplicar-producto-fitosanitario', data.id, data]);
	}

	public override deleteRegister() {
		if (this.model.id) {
			this.deleteRequest.safePerform(this.model);
			this.deleteRequest.response(() => {
				if (!this.deleteRequest.hasError) {
					this.getRequest.safePerform({ tipo: 'fitosanitario' } as never);
				}
			});
		} else {
			this.deleteRequest.hasError = true;
			throw new Error('Trying to DELETE a register without primary key');
		}
	}

	public showDetalle(data: ProductosModel): void {
		this.show('detalle', data, false);
		this.model.usos = [];

		const registro = String(data.num_registro ?? '').trim();

		if (registro !== '') {
			void this.productCatalogCache
				.getOrLoad<Uso[]>(
					this.getProductDetailCacheConfig(registro),
					() => this.formApi.magramaDetalleProducto.toPromise({ p3: registro } as never) as Promise<Uso[]>,
				)
				.then((usos) => {
					if ((usos || []).length > 0) {
						this.model.usos = usos;
					}
				})
				.catch((error: unknown) => {
					console.error('Error loading product detail:', error);
				});
		}

		const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');

		setTimeout(() => {
			if (elements[0]) {
				elements[0].scrollTop = 0;
			}
		}, 100);
	}

	private getProductDetailCacheConfig(registro: string): {
		namespace: string;
		name: string;
		ttlMs: number;
		params: Record<string, unknown>;
		userScope: string;
		clientScope: string;
	} {
		return {
			namespace: 'producto-add-list',
			name: 'magrama-detalle-producto',
			ttlMs: PRODUCT_DETAIL_CACHE_TTL_MS,
			params: { registro },
			userScope: String(StorageManager.getUser()?.id ?? 'anonymous'),
			clientScope: String(StorageManager.getClient()?.id ?? 'no-client'),
		};
	}

	public override show(modal: string, data: ProductosModel, closePreviousModal: boolean = true): void {
		let x;

		this.model = data;
		this.canShow[modal] = true;

		if (['info', 'delete'].includes(modal)) {
			const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

			this.form = new ProductosFitosanitariosListFormDefinition(formType, data);
		}

		if (modal === 'infoSdi') {
			this.sdiForm = new ProductosSdiListFormDefinition(+FormType.INFORMATIVE, data);
		}

		for (x in this.canShow) {
			if (x !== modal && this.canShow[x] && closePreviousModal) {
				this.canShow[x] = false;
			}
		}
	}

	public override hide(modal: string): void {
		this.canShow[modal] = false;
		if (modal !== 'detalle') {
			this.model = { nombre: '', materia_activa: '' };
			this.deleteRequest.reset();
			this.form = null;
			this.sdiForm = null;
		}
	}

	public globalConditionalStyle(
		value: string,
		col: ColInterface,
		_colGroup: ColInterface[],
		row: TreeNode<ProductosModel>,
	): ColStylesInterface {
		const producto = row.data as ProductosModel;

		if (Utils.isNumber(value) && col.field !== 'num_registro') {
			if (col.field === 'ps') {
				return { textAlign: 'center', paddingRight: '40px' };
			}
		}
		if (col.field === 'ps') {
			return { textAlign: 'center', paddingRight: '40px' };
		}

		let estiloVademecum: ColStylesInterface = { textAlign: 'center' };

		if (Utils.isNumber(value) || col.field === 'precio') {
			return {
				textAlign: 'center',
				paddingRight: '30px',
			};
		}

		if (col.field === 'fecha_caducidad') {
			estiloVademecum = {
				rowStyle: {
					color: 'black',
					backgroundColor: '#ffffff',
					borderBottom: '1px solid #dddddd',
				},
				textAlign: 'center',
			};

			const diffInsc = moment(new Date()).diff(Utils.toDate(producto.fecha_inscripcion ?? ''), 'months');

			if (diffInsc < 12) {
				estiloVademecum = {
					rowStyle: {
						color: 'black',
						backgroundColor: '#cbdecb',
						borderBottom: '1px solid #dddddd',
					},
					textAlign: 'center',
				};
			} else {
				estiloVademecum = {
					rowStyle: {
						color: 'black',
						backgroundColor: '#ffffff',
						borderBottom: '1px solid #dddddd',
					},
					textAlign: 'center',
				};
			}

			const diff = moment(new Date()).diff(Utils.toDate(producto.fecha_caducidad ?? ''), 'months');

			if (diff > 12) {
				estiloVademecum = {
					rowStyle: {
						color: 'white',
						backgroundColor: '#222222',
						borderBottom: '1px solid #dddddd',
					},
					textAlign: 'center',
				};
			} else if (diff > 6) {
				estiloVademecum = {
					rowStyle: {
						color: 'black',
						backgroundColor: '#ff7f7f',
						borderBottom: '1px solid #dddddd',
					},
					textAlign: 'center',
				};
			} else if (diff >= 0) {
				estiloVademecum = {
					rowStyle: {
						color: 'black',
						backgroundColor: '#ffcf78',
						borderBottom: '1px solid #dddddd',
					},
					textAlign: 'center',
				};
			}
		}

		return estiloVademecum;
	}

	switchSdi() {
		this.isShowingSdiProductos = !this.isShowingSdiProductos;
	}

	public globalVisualTransform(value: string, col: ColInterface) {
		if (Utils.isNumber(value)) {
			if (col.field === 'ps' || (col.field === 'envase' && environment.appName !== 'agroleza')) {
				return Utils.decimalFormat(value, 0);
			} else if (col.field === 'precio' || col.field === 'precio_venta') {
				return Utils.decimalFormat(value, 2, '.', ',', 2);
			} else if (col.field !== 'num_registro') {
				return Utils.decimalFormat(value, 2, '.', ',', 3);
			}
		}
		return value;
	}

	public initFilter() {
		this.filtering.addFilter((data: TreeNode<ProductosModel>[] | void) =>
			this.typeFilter.type
				? (data as TreeNode<ProductosModel>[])
						.filter(
							(it) =>
								moment(new Date()).diff(
									Utils.toDate((it as ProductosModel)[this.typeFilter.type]?.toString() ?? ''),
									'months',
								) >= this.typeFilter.mes1 &&
								moment(new Date()).diff(
									Utils.toDate((it as ProductosModel)[this.typeFilter.type]?.toString() ?? ''),
									'months',
								) < this.typeFilter.mes2,
						)
						.sort(Filtering.sort(this.typeFilter.type, 1))
				: data,
		);
	}

	public myFilter(type: string, mes1: number, mes2: number) {
		this.typeFilter.type = type;
		this.typeFilter.mes1 = mes1;
		this.typeFilter.mes2 = mes2;
		this.filtering.filter();
	}
}
